import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Fieldset, UniversalSelect } from '@feathr/components';
import { flattenError } from '@feathr/hooks';

import type { IPersonFieldOption } from '../GroupExportModal.utils';
import type { IPersonTabState } from './PersonTab.hooks';

export interface IPersonTabProps {
  state: IPersonTabState;
}

function PersonTab({ state }: Readonly<IPersonTabProps>): JSX.Element {
  const { t } = useTranslation();

  const {
    isCustomFieldsPending,
    personFieldOptions,
    selectedFieldOptions,
    fieldsError,
    handleSelectFields,
  } = state;

  return (
    <Fieldset>
      <UniversalSelect<IPersonFieldOption>
        isLoading={isCustomFieldsPending}
        isMulti={true}
        label={t('Fields')}
        menuPortalTarget={document.body}
        name={'person-fields'}
        onSelectMulti={handleSelectFields}
        options={personFieldOptions}
        validationError={flattenError(fieldsError)}
        value={selectedFieldOptions}
      />
    </Fieldset>
  );
}

export default PersonTab;
